<template>
  <div class="nav">
    <div
      :class="['first-level', item.status == 'expanded' ? 'expanded' : '']"
      v-for="(item, index) in menu"
      :key="item.url"
    >
      <span class="fw500" @click="setActive(index)"
        >{{ st(item.labelKey) }}<i class="iconfont"
      /></span>
      <div class="second-level">
        <span
          :key="second.url"
          @click="setViewLink(second.url)"
          v-for="second in item.children"
          :class="showLink === second.url ? 'active' : ''"
          >{{ st(second.labelKey) }}</span
        >
      </div>
    </div>
  </div>
</template>

<script setup>
import { onBeforeMount, ref } from 'vue'
import { useRouter } from 'vue-router'
import { useSellerI18n } from '@/composables/useSellerI18n'

const { st } = useSellerI18n()
const router = useRouter()
// 展示链接，默认about-artemis-ads
const showLink = ref('about-artemis-ads')
const menu = ref([
  {
    status: 'expanded',
    labelKey: 'helpNav.aboutArtemisAdsSection',
    url: 'about-artemis-ads-home',
    children: [
      {
        labelKey: 'helpNav.aboutArtemisAdsSection',
        url: 'about-artemis-ads',
      },
      {
        labelKey: 'helpNav.whyJoinArtemisAds',
        url: 'why-join-artemis-ads',
      },
      {
        labelKey: 'helpNav.howToJoinArtemisAdsAsBrand',
        url: 'how-to-join-artemis-ads-as-a-brand',
      },
      {
        labelKey: 'helpNav.artemisAdsPricingStructure',
        url: 'artemis-ads-pricing-structure',
      },
      {
        labelKey: 'helpNav.attributionDataAccessAuthorization',
        url: 'attribution-data-access-authorization',
      },
      {
        labelKey: 'helpNav.earningAmazonBrandReferralBonus',
        url: 'earning-amazon-brand-referral-bonus',
      },
      {
        labelKey: 'helpNav.brandReferralBonusRatesByCategory',
        url: 'brand-referral-bonus-rates-by-category',
      },
      {
        labelKey: 'helpNav.amazonAttributionModel',
        url: 'amazon-attribution-model',
      },
      {
        labelKey: 'helpNav.amazonAttributionAndSalesReporting',
        url: 'amazon-attribution-and-sales-reporting',
      },
      {
        labelKey: 'helpNav.promotionRequirementsOnArtemisAds',
        url: 'promotion-requirements-on-artemis-ads',
      },
      {
        labelKey: 'helpNav.multiBrandAndMultiProductPromotions',
        url: 'multi-brand-and-multi-product-promotions',
      },
      {
        labelKey: 'helpNav.whereWillPromotionPostsBeDisplayed',
        url: 'where-will-promotion-posts-be-displayed',
      },
    ],
  },
  {
    labelKey: 'helpNav.forSellerSection',
    url: 'for-seller',
    children: [
      {
        labelKey: 'helpNav.artemisAdsSellerAssociateHandbook',
        url: 'ArtemisAds',
      },
      {
        labelKey: 'helpNav.sellerGeneralAccountSetup',
        url: 'seller-general-account-setup',
      },
      {
        labelKey: 'helpNav.activateBrands',
        url: 'activate-brands',
      },
      {
        labelKey: 'helpNav.activateProducts',
        url: 'activate-products',
      },
      {
        labelKey: 'helpNav.manageMultipleSellers',
        url: 'manage-multiple-sellers',
      },
      {
        labelKey: 'helpNav.manageDealsInBulk',
        url: 'manage-deals-in-bulk',
      },
      {
        labelKey: 'helpNav.manageProductsInBulk',
        url: 'manage-products-in-bulk',
      },
      {
        labelKey: 'helpNav.amazonAttributionService',
        url: 'amazon-attribution-service',
      },
      {
        labelKey: 'helpNav.amazonAttributionLink',
        url: 'amazon-attribution-link',
      },
      {
        labelKey: 'helpNav.brandReferralBonus',
        url: 'brand-referral-bonus',
      },
    ],
  },
  {
    labelKey: 'helpNav.forPublisherSection',
    url: 'for-publisher',
    children: [
      {
        labelKey: 'helpNav.gettingStartedWithArtemisAds',
        url: 'getting-started-with-artemis-ads',
      },
      {
        labelKey: 'helpNav.commissionsAndSalesTracking',
        url: 'commissions-and-sales-tracking',
      },
      {
        labelKey: 'helpNav.promotionsAndGlobalReach',
        url: 'promotions-and-global-reach',
      },
      {
        labelKey: 'helpNav.creatingEngagingAndTrustworthyContent',
        url: 'creating-engaging-and-trustworthy-content',
      },
      {
        labelKey: 'helpNav.paymentsAndSupport',
        url: 'payments-and-support',
      },
    ],
  },
])

// 设置一级分类展开、收起状态
function setActive(index) {
  menu.value[index].status =
    menu.value[index].status == 'expanded' ? '' : 'expanded'
}

function setViewLink(url) {
  if(url == 'ArtemisAds') {
    window.open('https://scnmy6dg3ksd.feishu.cn/wiki/WHVqwgxE5iPqXGkDAkoc47cYnrh', '_blank')
    return
  }
  showLink.value = url
  router.push(`/help/${url}`)
  document.querySelector('.help-page').scrollIntoView()
}

onBeforeMount(() => {
  const currentPath = router.currentRoute.value.path.replace('/help/', '')

  if (currentPath) {
    let current = []

    showLink.value = currentPath

    for (let i = 0; i < menu.value.length; i++) {
      for (let j = 0; j < menu.value[i].children.length; j++) {
        if (currentPath == menu.value[i].children[j].url) {
          current = [i, j]
          break
        }
      }
      if (current.length) {
        break
      }
    }

    for (let i = 0; i < menu.value.length; i++) {
      menu.value[i].status = i === current[0] ? 'expanded' : ''
    }
  }
})
</script>

<style lang="less" scoped>
.nav {
  flex: 0 0 320px;
  padding: 24px;
  box-shadow: inset -1px 0 0 0 rgba(0, 0, 0, 0.07);
  span {
    cursor: pointer;
    color: var(--dark-1);
  }
  .first-level {
    display: flex;
    margin-bottom: 16px;
    flex-direction: column;
    > span {
      display: flex;
      font-size: 16px;
      line-height: 24px;
      align-items: center;
      justify-content: space-between;
      > i {
        line-height: 16px;
        &:before {
          display: block;
          font-size: 14px;
          content: '\e75f';
          font-style: normal;
          border-radius: unset;
          font-family: iconfont;
          background-color: unset;
          transform: rotate(-90deg);
          transition: transform ease 0.2s;
        }
      }
    }
  }
  .expanded {
    > span > i::before {
      transform: none;
    }
    .second-level {
      display: block;
    }
  }
  .second-level {
    display: none;
    margin-top: 8px;
    padding-left: 16px;
    > span {
      display: block;
      font-size: 14px;
      padding: 8px 16px;
      line-height: 20px;
      margin-left: -16px;
      &.active {
        font-weight: 500;
        border-radius: 8px;
        position: relative;
        background: #ebe4ff;
        color: var(--primary-text);
        &:before {
          left: 0;
          top: 8px;
          width: 3px;
          bottom: 8px;
          content: '';
          position: absolute;
          border-radius: 4px;
          background: var(--primary);
        }
      }
    }
  }
}
</style>